<h2 mat-dialog-title>{{ 'orders.resendToAttestor' | transloco }}</h2>
<mat-dialog-content>
@if (dialogMessage) {
  <div class="flex-container line-item">
      <span>{{ dialogMessage }}</span>
  </div>
}
  <div class="flex-container line-item">
      <mat-form-field appearance="outline" class="form-field">
        <mat-label>{{ 'orders.messageToAttestorOptional' | transloco }}</mat-label>
        <textarea matInput [(ngModel)]="resendMessage" data-testid="resend-textarea"></textarea>
      </mat-form-field>
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button color="accent" [mat-dialog-close]="{ shouldResend: false }">{{ 'common.buttons.cancel' | transloco }}</button>
  <span class="spacer"></span>
  <button mat-button color="warn" [mat-dialog-close]="{ shouldResend: true, message: resendMessage }">{{ 'orders.resend' | transloco }}</button>
</mat-dialog-actions>
